/**
 * Compact follower/subscriber count: `999` → `999`, `1500` → `1.5K+`,
 * `2_000_000` → `2M+`. Ported verbatim from PopshopRN's `formattedCount`
 * (`functions/ux/formattedCount.ts`) so the banner's "N Subscribers" pill reads
 * identically.
 */
export function formattedCount(count: number): string {
  if (count >= 1_000_000) {
    return `${(count / 1_000_000).toFixed(1).replace(/\.0$/, '')}M+`;
  }
  if (count >= 1_000) {
    return `${(count / 1_000).toFixed(1).replace(/\.0$/, '')}K+`;
  }
  return count.toString();
}
